import React, { Component } from 'react';
import { Modal, DatePicker, Select, Input, message, Spin } from 'antd';
import HighSearchInput from '../../common/HighSearchInput';
import CascaderCity from '../../common/CascaderCity';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import moment from 'moment';
import SearchRetrieve from '../../common/SearchRetrieve.new';

const { Option } = Select;
const dateFormat = "YYYY-MM-DD";
const hospitalLevelOptions = ['三级甲等', '三级乙等', '三级丙等', '二级甲等', '二级乙等', '二级丙等', '一级甲等', '一级乙等', '一级丙等', '其他'];

class LoseRecord extends Component {
    state = {
        params: {},
        visible: false,
        loading: false,
        renderHospital: true,
        needCourtyardArea: false, //院区必填判断
    }

    show = (parentRecord, record) => {
        const { userId } = parentRecord;
        const { cityId, provinceId } = record || {};
        const params = {
            userId,
            ...(record || {}),
            cityId: cityId ? [provinceId, cityId] : [],
        };
        this.setState({
            params,
            visible: true,
            isEdit: !!record,
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            hospitalOptions: {},
        });
    }

    submit = () => {
        const {
            isEdit,
            params: {
                userId,
                newlyHospitalDepartmentId,
                successfulDevelopmentTime,
                hospitalId,
                hospitalMainId,
                hospitalName,
                developmentType,
                hospitalLevel,
                cityId,
                hospitalProvince,
                hospitalCity,
                hospitalAddress,
                departmentName,
                courtyardArea,
            },
            hospitalOptions = {},
        } = this.state;
        if (!successfulDevelopmentTime) {
            message.warning('请选择成功开发时间');
            return;
        }
        if (!developmentType) {
            message.warning('请选择开发类型');
            return;
        } else if (developmentType == 'NEW') {
            if (!hospitalName) {
                message.warning('请输入医院名称');
                return;
            }
        } else {
            if (hospitalMainId) {
                // const isExist = hospitalOptions.some(item => item.value == hospitalId);
                // if (!isExist) {
                //     message.warning('请选择正确的医院');
                //     return;
                // }
            } else {
                message.warning('请选择医院');
                return;
            }
            if (!departmentName) {
                message.warning('请输入科室');
                return;
            }
        }

        const [ provinceId, hospitalCityId ] = cityId;
        let url;
        let newParams = {
            userId,
            newlyHospitalDepartmentId,
            successfulDevelopmentTime: successfulDevelopmentTime ? successfulDevelopmentTime.slice(0, 10) : '',
            hospitalName,
            hospitalId,
            developmentType,
            hospitalLevel,
            cityId: hospitalCityId,
            hospitalProvince,
            provinceId,
            hospitalCity,
            hospitalAddress,
            hospitalId,
            departmentName,
            courtyardArea,
        };
        if (isEdit) {
            url = API_URL.user.modifyNewlyHospitalDepartment;
        } else {
            url = API_URL.user.addNewlyHospitalDepartment;
        }
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url,
            data: newParams,
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                }, () => {
                    this.hide();
                    this.props.loadData(userId);
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleDateChange = (date, dateString, key) => {
        const { params } = this.state;
        params[key] = dateString;
        this.setState({ params });
    }

    handleInputChange = (e, key) => {
        const { params } = this.state;
        params[key] = e.target.value;
        this.setState({ params });
    }

    handleSelectChange = (value, key) => {
        const { params } = this.state;
        params[key] = value;

        const clearParams = {};
        if (key == 'developmentType') {
            params.hospitalId = '';
            params.hospitalName = '';
            params.hospitalLevel = '';
            params.cityId = [];
            params.hospitalProvince = '';
            params.hospitalCity = '';
            params.hospitalAddress = '';
            params.departmentName = '';
            clearParams.hospitalOptions = {};
            this.setState({
                renderHospital: false,
            }, () => {
                this.setState({ renderHospital: true })
            });
        }
        if (key == 'courtyardArea'){
            params.hospitalId = value.value;
            params.courtyardArea = value.text;
            const { hospitalLevel, hospitalProvince, hospitalCity, hospitalAddress } = value || {};
            Object.assign(params, {
                hospitalLevel,
                hospitalProvince,
                hospitalCity,
                hospitalAddress,
            });
        }
        this.setState({
            params,
            ...clearParams,
        });
    }

    handleHighSearchInputChange = ( options, idName, optionsName) => {
        const { params } = this.state;
        params[idName] = options.value;
        params.hospitalName = options.text;
        params.hospitalId = undefined;
        params.courtyardArea = undefined;
        params.hospitalLevel = undefined;
        params.hospitalProvince = undefined;
        params.hospitalAddress = undefined;
        if (idName == 'hospitalId') {
        }
        this.setState({
            params,
            [optionsName]: options,
        },() => this.state.params.hospitalMainId && this.queryCourtyardAreaList());
    }

    queryCourtyardAreaList = () => {
        if (this.timer) {
            clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
            const { params: { hospitalMainId } } = this.state;
            const options = {
                method: 'POST',
                url: API_URL.hospital.queryHospitalCourtyardAreaList,
                data: {    
                    hospitalMainId,
                },
                dataType: 'json',
                doneResult: res => {
                    const { datas } = res;
                    const needCourtyardArea = datas && datas[0].courtyardArea;
                    this.setState({ needCourtyardArea });
                }
            };
            $.sendRequest(options);
        }, 300);
    }

    handleCascaderCityChange = (value, selectedOptions, key) => {
        const { params } = this.state;
        const [{ label: hospitalProvince } = { label: '' }, { label: hospitalCity } = { label: '' }] = selectedOptions;
        params[key] = value;
        params.hospitalProvince = hospitalProvince;
        params.hospitalCity = hospitalCity;
        this.setState({ params });
    }

    getContent = () => {
        const { isEdit, params, visible, renderHospital, needCourtyardArea } = this.state;
        const {
            successfulDevelopmentTime,
            hospitalMainId,
            departmentName,
            developmentType,
            hospitalLevel,
            hospitalProvince,
            hospitalCity,
            hospitalAddress,
            cityId,
            courtyardArea,
            hospitalName,
        } = params;
        const newSuccessfulDevelopmentTime = successfulDevelopmentTime ? moment(successfulDevelopmentTime) : null;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        return (
            <ul className="modal-list">
                <li className="modal-item">
                    <div className="item-left">{asterisk}成功开发时间:</div>
                    <div className="item-right">
                        <DatePicker
                            placeholder="请选择"
                            style={{ width: 182 }}
                            format={dateFormat}
                            value={newSuccessfulDevelopmentTime}
                            onChange={(date, dateString) => this.handleDateChange(date, dateString, "successfulDevelopmentTime")}
                        />
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">{asterisk}开发类型:</div>
                    <div className="item-right">
                        <Select
                            style={{ width: 182 }}
                            value={developmentType || undefined}
                            placeholder="请选择"
                            onChange={value => this.handleSelectChange(value, 'developmentType')}
                        >
                            <Option value="NEW">新医院新科室开发</Option>
                            <Option value="EXIST">已有医院新科室开发</Option>
                        </Select>
                    </div>
                </li>
                {
                    developmentType == 'NEW' &&
                    <div>
                        <li className="modal-item">
                            <div className="item-left">{asterisk}医院名称:</div>
                            <div className="item-right">
                                <Input
                                    value={hospitalName}
                                    style={{ width: 240 }}
                                    placeholder="请输入"
                                    onChange={e => this.handleInputChange(e, 'hospitalName')}
                                />
                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left">院区:</div>
                            <div className="item-right">
                                <Input
                                    value={courtyardArea}
                                    style={{ width: 240 }}
                                    placeholder="请输入"
                                    onChange={value => this.handleInputChange(value, 'courtyardArea')}
                                />
                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left">等级:</div>
                            <div className="item-right">
                                <Select
                                    style={{ width: 182 }}
                                    value={hospitalLevel || undefined}
                                    placeholder="请选择"
                                    onChange={value => this.handleSelectChange(value, 'hospitalLevel')}
                                >
                                    {
                                        hospitalLevelOptions.map(i => <Option key={i} value={i}>{i}</Option>)
                                    }
                                </Select>
                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left">省市:</div>
                            <div className="item-right">
                                {
                                    visible &&
                                    <CascaderCity
                                        value={cityId}
                                        style={{ width: 182 }}
                                        onChange={(value, selectedOptions) => this.handleCascaderCityChange(value, selectedOptions, 'cityId')}
                                    />
                                }
                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left">详细地址:</div>
                            <div className="item-right">
                                <Input
                                    value={hospitalAddress}
                                    style={{ width: 240 }}
                                    placeholder="请输入"
                                    onChange={e => this.handleInputChange(e, 'hospitalAddress')}
                                />
                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left">科室:</div>
                            <div className="item-right">
                                <Input
                                    value={departmentName}
                                    style={{ width: 240 }}
                                    placeholder="请输入"
                                    onChange={e => this.handleInputChange(e, 'departmentName')}
                                />
                            </div>
                        </li>
                    </div>
                }
                {
                    developmentType == 'EXIST' &&
                    <div>
                        {
                            renderHospital && visible &&
                            <li className="modal-item">
                                <div className="item-left">{asterisk}医院名称:</div>
                                <div className="item-right">
                                    <SearchRetrieve
                                        isEdit={isEdit}
                                        keyword='hospitalName'
                                        style={{ width: 240 }}
                                        params={{ limit: 10, offset: 1 }}
                                        placeholder="输入医院名称自动检索"
                                        value={hospitalName}
                                        url={API_URL.hospital.queryHospitalMainList}
                                        config={{ id: 'hospitalMainId', name: 'hospitalMainName' }}
                                        onChange={options => this.handleHighSearchInputChange( options, 'hospitalMainId', 'hospitalOptions' )}
                                    />
                                </div>
                            </li>
                        }
                        <li className="modal-item">
                            <div className="item-left">院区:</div>
                            <div className="item-right">
                        
                            <SearchRetrieve
                                isEdit={isEdit}
                                keyword='hospitalName'
                                style={{ width: 240 }}
                                params={{ hospitalMainId }}
                                placeholder="输入院区名称自动检索"
                                value={courtyardArea}
                                disabled={ !needCourtyardArea || !hospitalMainId }
                                url={API_URL.hospital.queryHospitalCourtyardAreaList}
                                config={{ id: 'hospitalId', name: 'courtyardArea' }}
                                onChange={options => this.handleSelectChange( options, 'courtyardArea' )}
                            />
                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left">等级:</div>
                            <div className="item-right">{hospitalLevel}</div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left">省市:</div>
                            <div className="item-right">{hospitalProvince}{hospitalCity}</div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left">详细地址:</div>
                            <div className="item-right">{hospitalAddress}</div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left">{asterisk}科室:</div>
                            <div className="item-right">
                                <Input
                                    value={departmentName}
                                    style={{ width: 240 }}
                                    placeholder="请输入"
                                    onChange={e => this.handleInputChange(e, 'departmentName')}
                                />
                            </div>
                        </li>
                    </div>
                }
            </ul>
        )
    }

    render() {
        const { isEdit, visible, loading } = this.state;
        return (
            <Modal
                title={`${isEdit ? '修改' : '添加'}新开发医院科室`}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="setjde-modal addchildcontract"
                wrapClassName="vertical-center-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="480px"
            >
                 <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: '0 20px' }}>
                        {this.getContent()}
                    </div>
                </Spin>
            </Modal>
        )
    }
}

export default LoseRecord;


// WEBPACK FOOTER //
// ./src/components/user/teamManageEvaluate/UpdateDevelop.js